// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"3ad68af4","170":"474bfe42","926":"bcdbf588"}[chunkId] + ".chunk.js";
};